
import { useState, useEffect } from "react";
import { LeaderboardRecord } from "../types";
import { calculateAccuracy } from "../utils";

export const useChartData = (filteredData: LeaderboardRecord[]) => {
  const [chartData, setChartData] = useState<any[]>([]);
  const [historicalTrendsData, setHistoricalTrendsData] = useState<any[]>([]);

  const prepareChartData = () => {
    const currentYearTotal = {
      year: 'Current Year',
      forecast: filteredData.reduce((sum, item) => sum + (item.forecast || 0), 0),
      actual: filteredData.reduce((sum, item) => sum + item.achievement, 0),
      accuracy: calculateAccuracy(
        filteredData.reduce((sum, item) => sum + (item.forecast || 0), 0),
        filteredData.reduce((sum, item) => sum + item.achievement, 0)
      )
    };

    const previousYearTotal = {
      year: 'Previous Year',
      forecast: filteredData.reduce((sum, item) => sum + (item.y_1_forecast || 0), 0),
      actual: filteredData.reduce((sum, item) => sum + (item.y_1_actuals || 0), 0),
      accuracy: calculateAccuracy(
        filteredData.reduce((sum, item) => sum + (item.y_1_forecast || 0), 0),
        filteredData.reduce((sum, item) => sum + (item.y_1_actuals || 0), 0)
      )
    };

    const twoYearsAgoTotal = {
      year: 'Two Years Ago',
      forecast: filteredData.reduce((sum, item) => sum + (item.y_2_forecast || 0), 0),
      actual: filteredData.reduce((sum, item) => sum + (item.y_2_actuals || 0), 0),
      accuracy: calculateAccuracy(
        filteredData.reduce((sum, item) => sum + (item.y_2_forecast || 0), 0),
        filteredData.reduce((sum, item) => sum + (item.y_2_actuals || 0), 0)
      )
    };

    setChartData([twoYearsAgoTotal, previousYearTotal, currentYearTotal]);
  };

  const prepareHistoricalTrendsData = () => {
    const twoYearsAgoActuals = filteredData.reduce((sum, item) => sum + (item.y_2_actuals || 0), 0);
    const oneYearAgoActuals = filteredData.reduce((sum, item) => sum + (item.y_1_actuals || 0), 0);
    const currentYearActuals = filteredData.reduce((sum, item) => sum + item.achievement, 0);

    const previousYearYOY = twoYearsAgoActuals > 0 
      ? ((oneYearAgoActuals - twoYearsAgoActuals) / twoYearsAgoActuals * 100).toFixed(2) 
      : "N/A";
    const currentYearYOY = oneYearAgoActuals > 0 
      ? ((currentYearActuals - oneYearAgoActuals) / oneYearAgoActuals * 100).toFixed(2) 
      : "N/A";

    const trendsData = [
      { year: 'Two Years Ago', revenue: twoYearsAgoActuals, yoy: null },
      { year: 'Previous Year', revenue: oneYearAgoActuals, yoy: previousYearYOY },
      { year: 'Current Year', revenue: currentYearActuals, yoy: currentYearYOY }
    ];

    setHistoricalTrendsData(trendsData);
  };

  useEffect(() => {
    prepareChartData();
    prepareHistoricalTrendsData();
  }, [filteredData]);

  return {
    chartData,
    historicalTrendsData
  };
};
